import { render, staticRenderFns } from "./SavingsCategoryCard.vue?vue&type=template&id=5882fbf4&"
import script from "./SavingsCategoryCard.vue?vue&type=script&lang=js&"
export * from "./SavingsCategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./SavingsCategoryCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports